import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AuxiliaryBoiler from "../components/auxiliary-Boiler";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

const AuxilaryBoilersLog = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [boiler_Data, set_Boiler_Data] = useState([]);

  const GET_SHIP_BOILER_LISTS = async () => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ship_boiler_details_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_loader(false);
          set_Boiler_Data(res?.response_data);
        }
      });
    } catch (error) {
      set_loader(false);
      console.error("Error boiler list:", error);
    }finally{
       set_loader(false);
    }
  };

  useEffect(() => {
    GET_SHIP_BOILER_LISTS();
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {boiler_Data?.length > 0 ? (
              <>
                {boiler_Data?.map((_items) => (
                  <>
                    <AuxiliaryBoiler eng_log_basic_id={eng_log_basic_id} _items={_items} />
                  </>
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AuxilaryBoilersLog;
